import { useEffect, useState } from 'react'
import { Avatar, Badge, Tooltip, Zoom, Chip, Box } from '@mui/material'
import OptimusDialog from './OptimusDialog'

const Optimus = () => {

  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [offering, setOffering] = useState("")
  const [accessToken, setAccessToken] = useState("")
  const authorizedLicenses = ["explore", "optimize"]

  const handleClickOpen = (e) => {
    setAnchorEl(e.currentTarget)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (accessToken === "") {
      setAccessToken(JSON.parse(localStorage.getItem("accessToken")))
    } else if (offering === "") {
      const consultServer = sessionStorage.getItem('url-consult')
      fetch(`${consultServer}/client`, {
        headers: {
         Authorization: "Bearer ".concat(accessToken),
         'Content-Type': 'application/x-www-form-urlencoded'
      }}).then((response) => response.json()).then((client) => {
        const module = JSON.parse(client.module.replaceAll('§', '"'))
        sessionStorage.setItem('offering', module.offering)
        setOffering(module.offering)
      }).catch(() => setAccessToken(""))
    }
  }, [offering, accessToken])

  if (authorizedLicenses.includes(offering)) {
    return (
      <div>
        <Badge
          overlap='circular'
          sx={{ cursor: 'pointer' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          style={{
            margin: 0
          }}
          onClick={open ? handleClose : handleClickOpen}
          onLoad={setAnchorEl}
        >
          <Tooltip
            TransitionComponent={Zoom}
            enterDelay={1200}
            placement={'right'}
            title={localStorage.getItem('i18nextLng') === 'fr-FR' ? `Salut ! Je suis Optimus, votre assistant intelligent !` : `Hi! I'm Optimus, your intelligent assistant!`}
            arrow
          >
          <Box className="actions-left" sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
            <Avatar alt="Optimus" sx={{ width: 50, height: 50 }} src={'assets/avatar/Avarat-18.png'} /> {'Optimus'}
            <Chip style={{ marginLeft: '5px' }} label="beta" color="error" size="small" />
          </Box>
          </Tooltip>
        </Badge>
        <OptimusDialog
          onClose={handleClose}
          open={open}
          logo={'assets/avatar/Avarat-18.png'}
          anchorEl={anchorEl}
        />
      </div>
    )
  } else {
    return <></>
  }
}

export default Optimus
